import { createContext, useContext } from 'react';

export const PracticeBrandingContext = createContext({
  primaryColor: null,
  secondaryColor: null
});

export const usePracticeBranding = () => useContext(PracticeBrandingContext);
